(ns com.theplantscape.plant-web.components.forms.core
  (:require [clojure.string :as str]
            [clojure.set :refer [rename-keys]]))

(def fmt-opt-from-keyword (comp str/capitalize name))

(defn replace-slash-in-name-attributes [hm]
  (rename-keys
   hm
   (reduce (fn [hm k]
             (conj hm {k (keyword (str/replace (subs (str k) 1) #"/" "|"))}))
           {}
           (keys hm))))

(defn vec-remove
  "remove elem in vector"
  [pos coll]
  (into (subvec coll 0 pos) (subvec coll (inc pos))))

(defn fetch-atom-hm
  ([a path value] (swap! a assoc-in (vec (concat [:values] path)) value))
  ([a value] (or (-> @a :values value) "")))

(defn update-atom-hm
  ([a evt] (update-atom-hm a [:values] evt nil nil))
  ([a path evt] (update-atom-hm a path evt nil nil))
  ([a path evt name value]
   (swap! a assoc-in
          (conj path (keyword (or name (when evt (-> evt .-target .-name)))))
          (identity (or value (when evt (-> evt .-target .-value)))))))

(defn update-atom-idx-hm
  ([a evt] (update-atom-idx-hm a [:values] evt))
  ([a path evt]
   (swap! a assoc-in
          (conj path (keyword (-> evt .-target .-name)))
          (identity (-> evt .-target .-value)))))

(defn remove-atom-hm!
  "Remove value from hash map"
  ([a path]
   (let [path (if (vector? path) path [:values path])]
     (swap! a update-in (pop path) dissoc (last path) ))))

(defn append-atom-hm!
  "Store values in a set for uniqueness"
  ([a path value]
   (let [path (if (vector? path) path [:values path])]
     (when-not (get-in @a path) (swap! a assoc-in path []))
     (swap! a assoc-in path (vec (conj (get-in @a path) value))))))

(defn evt-append-atom-hm!
  "Store values in a set for uniqueness"
  ([a evt]
   (append-atom-hm! a
                    (keyword (-> evt .-target .-name))
                    (identity (-> evt .-target .-value)))))

(defn update-atom-ns-hm [ns a evt]
  (swap! a assoc-in [:values (keyword ns (-> evt .-target .-name))] (-> evt .-target .-value)))

